const CLIENT_STATUSES = {
  initial: { name: "initial", id: "initial" },
  confirmed: { name: "confirmed", id: "confirmed" },
  blocked: { name: "blocked", id: "blocked" },
  disabled: { name: "disabled", id: "disabled" },
};

export default CLIENT_STATUSES;
